import * as api from '../../services/task/apiTask';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import { browserHistory } from 'react-router';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

export function* saveTaskSaga(feathersApp) {
  yield takeEvery('SAVE_TASK', callSaveTask, feathersApp);
}

export function* fetchTaskForEditSaga(feathersApp) {
  yield takeEvery('FETCH_TASK_FOR_EDIT', callFetchTaskForEdit, feathersApp);
}

export function* fetchTaskListSaga(feathersApp) {
  yield takeEvery('FETCH_TASK_LIST', callFetchTaskList, feathersApp);
}

export function* deleteTaskSaga(feathersApp) {
  yield takeEvery('DELETE_TASK', callDeleteTask, feathersApp);
}

export function* fetchTasks(feathersApp) {
  yield takeLatest('FETCH_TASKS', callFetchTasks, feathersApp);
}

export function* callFetchTasks(feathersApp) {
  const filters = { 
    rows_per_page: 100,
    task_notif: true,
  };
  
  const params = { 
    filters,
    list_type: 'task' 
  };
  
  const { data, total } = yield call(apiCommon.getDocs, feathersApp, params) || [];
  yield put({ type: 'SHOW_TASKS_COUNT', payload: { data, counter: total }})
}

function* callSaveTask(feathersApp, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user = {} } = yield select();
    const data = { ...action.data };

    let result = yield call(api.saveTask, feathersApp, {
      tenant,
      user,
      data: data
    });

    const id = result && result.id;

    if (id) {
      yield callFetchTaskForEdit(feathersApp, { id, silent: true });
      browserHistory.push(`/admin/task/edit/${id}`);
      yield common.doneSaveRecord(result, 'Task was saved');
    } else {
      yield common.showErrorSaveRecord(new Error('Error in saving : Task'));
    }

  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

function* callFetchTaskForEdit(feathersApp, action) {
  try {
    yield common.showProgressDataById();
    const { tenant, user } = yield select();
    const { id } = action;
    if (id) {
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchTaskById, feathersApp, fetchParams);
      doc.assignees = [...(doc.assignees || []).map(a => a.assignee_id)];

      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}

function* callFetchTaskList(feathersApp, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'task'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* callDeleteTask(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;

    if (id) {
      const { tenant, user } = yield select();
      const params = { tenant, user, id };
      yield call(api.deleteTask, feathersApp, params);
    }
    
    yield common.doneDeleteRecord(id, 'task');
    browserHistory.push('/admin/task');
  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}